import React from 'react';
import { PropTypes } from 'prop-types';

class MenuGroup extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = { open: false };
  }

  toggle(event) {
    this.setState({ open: !this.state.open });
  }

  render() {
    return (
      <li className={(this.state.open ? "open" : "")}>
        <a onClick={this.toggle} className="sub-menu" {...this.props}>{this.props.title}</a>
        <ul style={{ display: (this.state.open ? "block" : "") }}>
          {this.props.children}
        </ul>
      </li>
    );
  }
}

MenuGroup.propTypes = {
  title: PropTypes.string
}

export default MenuGroup;



// WEBPACK FOOTER //
// ./src/components/shared/MenuGroup.js